import { useEffect, useRef, useState } from 'react'
import { Package } from '../../types'
import { useLanguage } from '../../contexts/LanguageContext'
import styles from './PackagesPreview.module.css'

const PackagesPreview = () => {
  const { t } = useLanguage()
  const [currentIndex, setCurrentIndex] = useState(0)
  const sliderRef = useRef<HTMLDivElement>(null)

  const packages: Package[] = [
    {
      id: '1',
      name: t('packages.package1'),
      price: 4500,
      serviceType: 'kurumsal-web',
      description: t('packages.package1Desc')
    },
    {
      id: '2',
      name: t('packages.package2'),
      price: 18000,
      serviceType: 'urun-yonetim',
      description: t('packages.package2Desc')
    },
    {
      id: '3',
      name: t('packages.package3'),
      price: 30000,
      serviceType: 'e-ticaret',
      description: t('packages.package3Desc')
    }
  ]

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => {
        const nextIndex = prev + 1
        if (nextIndex >= packages.length) {
          return 0
        }
        return nextIndex
      })
    }, 5000)

    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    if (sliderRef.current) {
      const container = sliderRef.current
      const firstCard = container.querySelector(`.${styles.packageCard}`) as HTMLElement
      if (firstCard) {
        const cardWidth = firstCard.offsetWidth
        const gap = 24 // 1.5rem = 24px
        const scrollPosition = currentIndex * (cardWidth + gap)
        container.scrollTo({
          left: scrollPosition,
          behavior: 'smooth'
        })
      }
    }
  }, [currentIndex])

  const handlePackageClick = (pkg: Package) => {
    window.location.href = `/ozel-site-olustur?type=${pkg.serviceType}`
  }


  return (
    <section id="packages-preview" className={styles.packagesPreview}>
      <div className={styles.container}>
        <div className={styles.header}>
          <p className={styles.pill}>{t('packages.pill')}</p>
          <h2 className={styles.title}>{t('packages.title')}</h2>
          <p className={styles.subtitle}>
            {t('packages.subtitle')}
          </p>
        </div>

        <div className={styles.sliderWrapper}>
          <div className={styles.sliderTrack} ref={sliderRef}>
            {packages.map((pkg) => (
              <div key={pkg.id} className={styles.packageCard}>
                <h3 className={styles.packageName}>{pkg.name}</h3>
                <p className={styles.packageDescription}>{pkg.description}</p>
                <button
                  className={styles.addToCartBtn}
                  onClick={() => handlePackageClick(pkg)}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                  </svg>
                  <span>{t('packages.createSite')}</span>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </button>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.dots}>
          {packages.map((_, index) => (
            <button
              key={index}
              className={`${styles.dot} ${currentIndex === index ? styles.active : ''}`}
              onClick={() => setCurrentIndex(index)}
              aria-label={`Paket ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  )
}

export default PackagesPreview

